import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { Algorithm } from '@app/models/algorithm.interface';
import { AuthService } from '@app/services/auth.service';
import { AlgorithmHelperService } from '@app/services/helpers/algorithm-helper.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faCirclePlus,
  faArrowLeft 
 } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-algorithms',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './listing.page.html',
    styleUrl: './listing.page.scss'
})
export class AlgorithmsPage {
  public title = 'Algorithms';
  algorithms$: Observable<Algorithm[]>;

  faCirclePlus = faCirclePlus;
  faArrowLeft = faArrowLeft;

  constructor(
    private algorithmHelper: AlgorithmHelperService,
    public auth: AuthService,
  ) {
    this.algorithms$ = this.algorithmHelper.getAll();
  }
}
